import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { getMarketChannelById } from '@/api/common'

@Component({
    filters: {
        formatDate(val: "string") {
            return formatDate('yyyy-MM-dd', new Date(val))
        }
    }
})
export default class SeeChannel extends Vue {
    // ------ data ------
    channelType = ""
    channelName = ""
    launchStartTime = new Date()
    remark = ""
    newChannelTime = formatDate('yyyy-MM-dd', new Date())
    marketDutyUserId = ""
    marketDutyUserName = ""
    marketDutyUserList = []
    channelId = 0
    newChannelUserName = ""

    // ------ compunted ------

    // ------ mounted -------
    mounted() {
        this.channelId = Number(this.$route.query.id ? this.$route.query.id : '')
        this.getChannelInfo()
    }

    // ------ methods ------
    async getChannelInfo() {
        const data: any = await getMarketChannelById(this.channelId)
        const { beginAt, createUserRealName, createdAt, directorUserRealName, marketChannelTypeName, remark, name } = data.marketChannel
        this.channelType = marketChannelTypeName
        this.channelName = name
        this.launchStartTime = beginAt
        this.remark = remark
        this.newChannelUserName = createUserRealName
        this.newChannelTime = formatDate('yyyy-MM-dd', new Date(createdAt))
        this.marketDutyUserName = directorUserRealName
    }

}